/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minimum: NonNullable<unknown>, maximum: NonNullable<unknown> }} Case_Payment_Installment_Amount_RangeInputs */

const en_case_payment_installment_amount_range = /** @type {(inputs: Case_Payment_Installment_Amount_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minimum} – ${i?.maximum}`)
};

const pt_br2_case_payment_installment_amount_range = /** @type {(inputs: Case_Payment_Installment_Amount_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minimum} – ${i?.maximum}`)
};

/**
* | output |
* | --- |
* | "{minimum} – {maximum}" |
*
* @param {Case_Payment_Installment_Amount_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_installment_amount_range = /** @type {((inputs: Case_Payment_Installment_Amount_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Installment_Amount_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_installment_amount_range(inputs)
	return pt_br2_case_payment_installment_amount_range(inputs)
});